import axios from 'axios';

function getCallerUrl(): string {
  return window.location.hostname;
}

function createMiddlewareClient(middlewareUrl: string) {
  const client = axios.create({
    baseURL: middlewareUrl,
    headers: {
      'Content-Type': 'application/json',
      'x-caller-url': getCallerUrl(),
    },
  });

  return client;
}

export interface RechargeNumero {
  numero: string;
  id_plano: number;
}

export interface RechargeRequest {
  metodo_pagamento: string;
  numeros: RechargeNumero[];
}

export interface RechargeResponse {
  success?: boolean;
  message?: string;
  link_pagamento?: string;
  retorno?: boolean;
  mensagem?: string;
  recarga?: {
    link_pagamento?: string;
    [key: string]: any;
  };
  data?: any;
}

export interface PortabilityRequest {
  numero_contel: string;
  doador_numero: string;
  doador_id_operadora: number;
  sistema_origem?: string;
}

export interface PortabilityResponse {
  success: boolean;
  message?: string;
  protocolo?: string;
  data?: any;
}

export interface Operator {
  id: number;
  descricao: string;
}

// --- Plan types (API /planos response) ---

export interface Plan {
  id: number;
  plano: string;
  internet_padrao: string;
  categoria?: string;
  categoria_id?: string;
  valor: number;
  nome_plano: string;
  ligacoes: string;
  sms: string;
  detalhamento: string;
  descricao_detalhamento: string;
  cor: string;
  beneficios: string[];
  aplicativos: string[];
}

const plansRequestCache = new Map<string, Promise<Plan[]>>();

export async function fetchPlans(middlewareUrl: string): Promise<Plan[]> {
  const client = createMiddlewareClient(middlewareUrl);
  const response = await client.get<{ data: Plan[] }>('/planos');
  return response.data.data;
}

export function fetchPlansCached(middlewareUrl: string): Promise<Plan[]> {
  const cachedRequest = plansRequestCache.get(middlewareUrl);
  if (cachedRequest) {
    return cachedRequest;
  }

  const request = fetchPlans(middlewareUrl).catch((error) => {
    plansRequestCache.delete(middlewareUrl);
    throw error;
  });

  plansRequestCache.set(middlewareUrl, request);
  return request;
}

export async function fetchOperators(middlewareUrl: string): Promise<Operator[]> {
  const client = createMiddlewareClient(middlewareUrl);
  const response = await client.get<{ data: Operator[] }>('/portabilidade/operadorasDisponiveis');
  return response.data.data;
}

// --- POST functions ---

export async function submitRecharge(
  middlewareUrl: string,
  payload: RechargeRequest
): Promise<RechargeResponse> {
  const client = createMiddlewareClient(middlewareUrl);
  const response = await client.post<RechargeResponse>('/recarga/solicitar', payload);
  return response.data;
}

export async function submitPortability(
  middlewareUrl: string,
  payload: PortabilityRequest
): Promise<PortabilityResponse> {
  const client = createMiddlewareClient(middlewareUrl);
  const response = await client.post<PortabilityResponse>('/portabilidade/solicitar', payload);
  return response.data;
}
